import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-target-list',
  templateUrl: './target-list.component.html',
  styleUrls: ['./target-list.component.scss'],
})
export class TargetListComponent {
  displayedColumns = ['name', 'type'];
  entities = [];

  constructor(
    public dialogRef: MatDialogRef<TargetListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.entities = this.data.entities;
  }
}
